import React from 'react';
import { useTranslation } from 'react-i18next';
import { MultiSelect } from 'primereact/multiselect';
import { FormikProps } from 'formik';

import { ColumnDto, DataSourceDto } from '../../../../../../../typescript-axios';
import { isFormFieldInvalid, getFormErrorMessage } from '../../../utils/form_utils';

interface StepColumnSelectionProps {
    formik: FormikProps<{ dataSource: DataSourceDto }>;
    columnOptions: Record<string, ColumnDto>;
}

export const StepColumnSelection: React.FC<StepColumnSelectionProps> = ({
    formik,
    columnOptions,
}) => {
    const { t } = useTranslation();

    const currentColumns: ColumnDto[] = formik.values.dataSource.query_definition?.columns ?? [];

    const selectedColumnKeys = currentColumns
        .map((col) =>
            Object.entries(columnOptions).find(
                ([, dto]) => dto.table === col.table && dto.column === col.column
            )?.[0]
        )
        .filter((key): key is string => key !== undefined);

    const fieldPath = 'dataSource.query_definition.columns';

    return (
        <div className="field col-12">
            <label
                htmlFor="input-create-datasource-selected_columns"
                className="font-medium"
            >
                {t('pages.dashboards.datasource.select_columns')}
            </label>
            <MultiSelect
                id="input-create-datasource-selected_columns"
                name="selected_columns"
                value={selectedColumnKeys}
                options={Object.keys(columnOptions)}
                onChange={async (e) => {
                    const newColumns = e.value.length > 0
                        ? e.value.map((key: string) => columnOptions[key])
                        : undefined;
                    await formik.setFieldValue(fieldPath, newColumns);
                    formik.setFieldTouched(fieldPath, true, true);
                }}
                display="chip"
                className={isFormFieldInvalid(fieldPath, formik.touched, formik.errors) ? 'p-invalid' : ''}
                style={{ width: '100%' }}
            />
            {isFormFieldInvalid(fieldPath, formik.touched, formik.errors) && (
                <small className="p-error block mt-1">
                    {getFormErrorMessage(fieldPath, formik.touched, formik.errors)}
                </small>
            )}
        </div>
    );
};